var _linearGradient, _path, _linearGradient2, _path2, _radialGradient, _rect, _g, _linearGradient3, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: -1404,
    x2: -1404,
    y1: 244.987,
    y2: 251.012,
    gradientTransform: "matrix(-1 0 0 1 -1380 -210)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M14,38v-3h20v3l13,0.3V40c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1v-1.4L14,38z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 8.364,
    x2: 38.396,
    y1: 217.308,
    y2: 242.647,
    gradientTransform: "translate(0 -210)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M42,34H6c-1.1,0-2-0.9-2-2V9c0-1.1,0.9-2,2-2h36c1.1,0,2,0.9,2,2v23C44,33.1,43.1,34,42,34z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 194.22,
    cy: 286.363,
    r: 97.034,
    gradientTransform: "matrix(.8095 0 0 .7188 -108.78 -148.983)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#23d9d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#23d4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#21c7dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#1fb0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#1c91ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1969f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#1860fb"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 23,
    x: 6,
    y: 9,
    fill: "url(#SVGID_3_)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4,25.9c-0.4,0-0.7-0.1-1-0.4l-4-4c-0.3-0.3-0.4-0.6-0.4-1s0.1-0.7,0.4-1l4-4c0.3-0.3,0.6-0.4,1-0.4 s0.7,0.1,1,0.4l0.8,0.8c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-2.1,2.1l2.1,2.1c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-0.8,0.8 C19.1,25.8,18.8,25.9,18.4,25.9z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,25.4c-0.2,0-0.5-0.1-0.6-0.3l-4-4c-0.4-0.4-0.4-0.9,0-1.3l4-4c0.2-0.2,0.4-0.3,0.6-0.3s0.5,0.1,0.6,0.3l0.8,0.8 c0.4,0.4,0.4,0.9,0,1.3l-2.5,2.5l2.5,2.5c0.4,0.4,0.4,0.9,0,1.3L19,25.1C18.8,25.3,18.6,25.4,18.4,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1d25",
    d: "M19.5,17.1l-0.8-0.8c-0.2-0.2-0.4-0.2-0.6,0l-4,4c-0.2,0.2-0.2,0.4,0,0.6l4,4c0.2,0.2,0.4,0.2,0.6,0l0.8-0.8 c0.2-0.2,0.2-0.4,0-0.6l-2.8-2.8l2.8-2.8C19.7,17.5,19.7,17.3,19.5,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,25.9c-0.4,0-0.7-0.1-1-0.4l-0.8-0.8c-0.3-0.3-0.4-0.6-0.4-1s0.1-0.7,0.4-1l2.1-2.1l-2.1-2.1 c-0.3-0.3-0.4-0.6-0.4-1s0.1-0.7,0.4-1l0.8-0.8c0.3-0.3,0.6-0.4,1-0.4s0.7,0.1,1,0.4l4,4c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1 l-4,4C30.4,25.8,30,25.9,29.6,25.9z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,25.4c-0.2,0-0.5-0.1-0.6-0.3l-0.8-0.8c-0.4-0.4-0.4-0.9,0-1.3l2.5-2.5L28.1,18c-0.4-0.4-0.4-0.9,0-1.3l0.8-0.8 c0.2-0.2,0.4-0.3,0.6-0.3s0.5,0.1,0.6,0.3l4,4c0.4,0.4,0.4,0.9,0,1.3l-4,4C30.1,25.3,29.9,25.4,29.6,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1d25",
    d: "M33.9,20.2l-4-4c-0.2-0.2-0.4-0.2-0.6,0l-0.8,0.8c-0.2,0.2-0.2,0.4,0,0.6l2.8,2.8l-2.8,2.8 c-0.2,0.2-0.2,0.4,0,0.6l0.8,0.8c0.2,0.2,0.4,0.2,0.6,0l4-4C34,20.7,34,20.4,33.9,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7,29c-0.4,0-0.8-0.2-1-0.5c-0.3-0.3-0.3-0.7-0.3-1.1l2.9-14.1c0.1-0.7,0.7-1.1,1.4-1.1h1.5 c0.4,0,0.8,0.2,1,0.5c0.3,0.3,0.3,0.7,0.3,1.1l-2.9,14.1c-0.1,0.7-0.7,1.1-1.4,1.1H21.7z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7,28.5c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.2-0.2-0.4-0.2-0.7l2.9-14.1c0.1-0.4,0.5-0.7,0.9-0.7h1.5c0.2,0,0.5,0.1,0.6,0.3 s0.2,0.4,0.2,0.7l-2.9,14.1c-0.1,0.4-0.5,0.7-0.9,0.7H21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1d25",
    d: "M26.3,13.1h-1.5c-0.2,0-0.4,0.1-0.4,0.3l-2.9,14.2c0,0.2,0.1,0.4,0.3,0.4h1.5c0.2,0,0.4-0.1,0.4-0.3 l2.9-14.2C26.6,13.3,26.5,13.1,26.3,13.1z"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    x1: 24,
    x2: 24,
    y1: 243.989,
    y2: 249.01,
    gradientTransform: "translate(0 -210)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#484b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#565b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#626a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#6b757d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#717b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#727d86"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M46.9,38.3L44,34.8c-0.4-0.5-1-0.8-1.6-0.8h-37c-0.6,0-1.2,0.3-1.6,0.8l-2.9,3.6c-0.2,0.3,0,0.7,0.3,0.7h15 c0.4,0,0.7-0.2,0.9-0.6l0.4-0.9c0.2-0.3,0.5-0.6,0.9-0.6h10.8c0.4,0,0.7,0.2,0.9,0.6l0.4,0.9c0.2,0.3,0.5,0.6,0.9,0.6h15 C46.9,39,47.1,38.6,46.9,38.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.1,20.8l4,4c0.2,0.2,0.4,0.2,0.6,0l0.8-0.8c0.2-0.2,0.2-0.4,0-0.6l-4-4c-0.2-0.2-0.4-0.2-0.6,0l-0.8,0.8 C14,20.4,14,20.7,14.1,20.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.5,21.7l4-4c0.2-0.2,0.2-0.4,0-0.6l-0.8-0.8c-0.2-0.2-0.4-0.2-0.6,0l-4,4c-0.2,0.2-0.2,0.4,0,0.6l0.8,0.8 C15.1,21.8,15.4,21.8,15.5,21.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.9,20.8l-4,4c-0.2,0.2-0.4,0.2-0.6,0l-0.8-0.8c-0.2-0.2-0.2-0.4,0-0.6l4-4c0.2-0.2,0.4-0.2,0.6,0l0.8,0.8 C34,20.4,34,20.7,33.9,20.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.5,21.7l-4-4c-0.2-0.2-0.2-0.4,0-0.6l0.8-0.8c0.2-0.2,0.4-0.2,0.6,0l4,4c0.2,0.2,0.2,0.4,0,0.6L33,21.7 C32.9,21.8,32.6,21.8,32.5,21.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.3,13.1h-1.5c-0.2,0-0.4,0.1-0.4,0.3l-2.9,14.2c0,0.2,0.1,0.4,0.3,0.4h1.5c0.2,0,0.4-0.1,0.4-0.3l2.9-14.2 C26.6,13.3,26.5,13.1,26.3,13.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.d1cf91ab59352a3bb9d45d429e2c6904.svg";
export { ForwardRef as ReactComponent };